export default "__VITE_ASSET__CSSx0jZc__"